export enum OfferTextModuleTypeEnum {
    DEALER_EK_OFFER = 'Händler-EK Angebot:',
    ORDERED_QUANTITY_PROLONGABLE = 'Abnahmemengen verlängerbar',
    SPECIAL_PRICE = 'Sonderpreis',
}
